import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/navbar.css";

const Navbar: React.FC = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const className = "is-sticky";
    if (isSticky) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
  }, [isSticky]);

  useEffect(() => {
    const handleResize = () => {
      // Her resize'da menüyü kapat, breakpoint fark etmeksizin
      setIsMenuOpen(false);
    };
    window.addEventListener("resize", handleResize, { passive: true });
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (!isMenuOpen) return;
      const navEl = navRef.current;
      if (navEl && !navEl.contains(e.target as Node)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside, { passive: true });
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMenuOpen]);

  const toggleMenu = () => setIsMenuOpen((open) => !open);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav ref={navRef} className={`navbar${isSticky ? " sticky" : ""}`}>
      <Link to="/" className="nav-logo" aria-label="Tim Elektrik">
        <img src="/images/logo.png" alt="Tim Elektrik" />
      </Link>

      <button
        className={`menu-toggle${isMenuOpen ? " open" : ""}`}
        aria-expanded={isMenuOpen}
        aria-label="Menüyü aç/kapat"
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul className={`menu nav-menu${isMenuOpen ? " open" : ""}`} id="menu">
        <li><Link to="/" onClick={closeMenu}>Anasayfa</Link></li>
        <li><Link to="/about" onClick={closeMenu}>Hakkımızda</Link></li>
        <li><Link to="/services" onClick={closeMenu}>Hizmetlerimiz</Link></li>
        <li><Link to="/gallery" onClick={closeMenu}>Galeri</Link></li>
        <li><Link to="/contact" onClick={closeMenu}>İletişim</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;